import ChartBubble, { TOP_CHARTS_TYPES } from '@/pages/intelligence/components/ChartBubble';
import { handleSerieSymbolConfigByDataSet } from '@intelligence/utils/echartsUtils';
import {
  BASE_ECHART_OPTION,
  BASE_LINE_SERIES_OPTION,
} from '@/pages/intelligence/pages/Compare/PcConsoleGames/constants/echart';
import type {
  IEChartDataEntity,
  IEChartOption,
  IEChartDynamicOption,
  IEChartSeriesOption,
  ITooltipComponentOption,
  ILegendComponentOption,
} from '@/pages/intelligence/types/echart';

// function createTooltipFormatter(
//   title?: string,
//   serieNameFormatter?: (params: string) => string,
//   leftTitleFormatter?: (params: string) => string,
//   valueFormatter?: (params: any) => any,
// ): (params: any) => string {
//   return (params: any[]): string => {
//     const leftTitle = (() => {
//       let leftTitleTemp = params?.[0]?.axisValueLabel;
//       if (typeof leftTitleFormatter === 'function') {
//         leftTitleTemp = leftTitleFormatter(leftTitleTemp);
//       }
//       return leftTitleTemp;
//     })();
//     const firstColumnHeaderHTMLStr = `
//       <section class="dbi-base-line-chart-tooltip-header">
//         <span>${leftTitle || '-'}</span>
//       </section>
//     `;
//     const lastColumnHeaderHTMLStr = `
//       <section class="dbi-base-line-chart-tooltip-header">
//         <span>${title || ''}</span>
//       </section>
//     `;
//     const firstColumnHTMLStrs = [];
//     const lastColumnHTMLStrs = [];
//     let firstColumnHTMLStr = '';
//     let lastColumnHTMLStr = '';
//     const sortedParams = [...params].sort((a, b) => {
//       const aValue = Number.parseFloat(a?.value);
//       const bValue = Number.parseFloat(b?.value);
//       const aNaN = Number.isNaN(aValue);
//       const bNaN = Number.isNaN(bValue);
//       if (aNaN && bNaN) return 0;
//       if (bNaN) return -1;
//       if (aNaN) return 1;
//       return bValue - aValue;
//     });
//     for (let i = 0; i < sortedParams?.length; i++) {
//       const t = sortedParams?.[i];
//       const seriesName = t?.seriesName;
//       const formattedSeriesName =
//         typeof serieNameFormatter === 'function' ? serieNameFormatter(seriesName) : seriesName;
//       let value = t?.value;
//       if (typeof valueFormatter === 'function') {
//         value = valueFormatter(value);
//       }
//       firstColumnHTMLStr = `
//         <section class="dbi-base-line-chart-tooltip-list-item">
//           <span class="dbi-base-line-chart-tooltip-list-item-dot" style="background-color: ${t?.color};"></span>
//           <span class="dbi-base-line-chart-tooltip-list-item-name">${formattedSeriesName || '-'}</span>
//         </section>
//       `;
//       lastColumnHTMLStr = `
//         <section class="dbi-base-line-chart-tooltip-list-item">
//           <span class="dbi-base-line-chart-tooltip-list-item-name">${value}</span>
//         </section>
//       `;
//       firstColumnHTMLStrs.push(firstColumnHTMLStr);
//       lastColumnHTMLStrs.push(lastColumnHTMLStr);
//     }

//     return `
//       <section class="dbi-base-line-chart-tooltip">
//         <section class="dbi-base-line-chart-tooltip-left">
//           ${firstColumnHeaderHTMLStr}
//           <section class="dbi-base-line-chart-tooltip-list">${firstColumnHTMLStrs.join('')}</section>
//         </section>
//         <section class="dbi-base-line-chart-tooltip-right">
//           ${lastColumnHeaderHTMLStr}
//           <section class="dbi-base-line-chart-tooltip-list">${lastColumnHTMLStrs.join('')}</section>
//         </section>
//       </section>
//     `;
//   };
// }

function createTooltipFormatterNew(
  title?: string,
  serieNameFormatter?: (params: string) => string,
  leftTitleFormatter?: (params: string) => string,
  valueFormatter?: (params: any) => any,
): (params: any) => string {
  return (params: any) => {
    return ChartBubble({
      topChartsType: TOP_CHARTS_TYPES.COMPARE_PC_CONSOLE_LINE,
      chartType: 'line',
      imageType: '', // pc console compare折线图浮窗没有展示游戏icon，所以这个可以传空
      headerLeftTitle: '',
      secondTitleRight: title,
      data: params,
      serieNameFormatter,
      headerLeftTitleFormatter: leftTitleFormatter,
    });
  };
}

/**
 * 获取折线图静态配置项，即直接塞给echarts的配置项，静态配置 不包含 依赖源数据的配置
 * @returns 折线图顶层配置项
 */
export const getChartStaticOptionData = (): IEChartOption => {
  const option: IEChartOption = {
    ...BASE_ECHART_OPTION,
    tooltip: {
      ...BASE_ECHART_OPTION?.tooltip,
      // 如需要设置hover浮窗内，纵向滚动时，可设置该配置为true，即可开启hover浮窗交互
      enterable: false,
      className: 'dbi-base-chart-tooltip-primary-style',
      // backgroundColor: 'rgba(0, 0, 0, 0.75)'
    },
    yAxis: [
      {
        // @ts-ignore
        ...BASE_ECHART_OPTION?.yAxis?.[0],
        alignTicks: true,
      },
    ],
  };
  return option;
};

/**
 * 获取初始配置项
 * @returns 初始配置项
 */
export const getChartInitialOptionData = (config?: {
  tooltipTitle?: string;
  tooltipOption?: ITooltipComponentOption;
  legendOption?: ILegendComponentOption | ILegendComponentOption[];
  serieNameFormatter?: (name: string) => string;
  xAxisLabelFormatter?: (name: string) => string;
  yAxisLabelFormatter?: (name: string) => string;
  tooltipFormatter?: (params: any) => string;
}): IEChartOption => {
  const {
    tooltipTitle,
    tooltipOption,
    legendOption,
    serieNameFormatter,
    xAxisLabelFormatter,
    yAxisLabelFormatter,
    tooltipFormatter,
  } = config || {};
  let initialOption: IEChartOption = getChartStaticOptionData?.();
  initialOption = {
    ...initialOption,
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0)',
      ...initialOption?.tooltip,
      ...tooltipOption,
      formatter:
        typeof tooltipFormatter === 'function'
          ? tooltipFormatter
          : createTooltipFormatterNew(tooltipTitle, serieNameFormatter, xAxisLabelFormatter, yAxisLabelFormatter),
    },
    xAxis: {
      ...initialOption?.xAxis,
      axisLabel: {
        // @ts-ignore
        ...initialOption?.xAxis?.axisLabel,
        formatter: xAxisLabelFormatter,
      },
    },
    yAxis: [
      {
        // @ts-ignore
        ...initialOption?.yAxis?.[0],
        axisLabel: {
          // @ts-ignore
          ...initialOption?.yAxis?.[0]?.axisLabel,
          formatter: yAxisLabelFormatter,
        },
      },
    ],
    legend: Array.isArray(legendOption)
      ? legendOption.map((item) => ({ ...initialOption?.legend, ...item, formatter: serieNameFormatter }))
      : {
        ...initialOption?.legend,
        formatter: serieNameFormatter,
      },
  };

  return initialOption;
};

const getChartDynamicOptionDataByXAxisEncode = (
  data: IEChartDataEntity[],
  xAxisEncode?: string,
  xAxisDataSortter?: (xAxisData: string[]) => string[],
): IEChartDynamicOption => {
  const option: IEChartDynamicOption = {
    xAxis: {
      data: [],
    },
    series: [],
    dataset: {
      dimensions: [],
      source: [],
    },
  };

  if (!Array.isArray(data)) return option;
  if (!xAxisEncode?.trim()) return option;

  const xAxisDataMap: {
    [key: string]: boolean;
  } = {};
  const seriesAnddimensionsMap: {
    [key: string]: boolean;
  } = {};

  option.dataset.dimensions.push(xAxisEncode);

  for (const dataItem of data) {
    const xAxisDataItem = dataItem?.[xAxisEncode];
    if (!xAxisDataItem) continue;
    if (!xAxisDataMap[xAxisDataItem]) {
      option.xAxis.data.push(xAxisDataItem);
      xAxisDataMap[xAxisDataItem] = true;
    }
    const otherKeys = Object.keys(dataItem).filter((key) => key !== xAxisEncode);
    for (const otherKey of otherKeys) {
      if (!otherKey?.trim()) continue;
      if (!seriesAnddimensionsMap[otherKey]) {
        option.series.push({
          ...BASE_LINE_SERIES_OPTION,
          name: otherKey,
          showSymbol: true,
        });
        option.dataset.dimensions.push(otherKey);
        seriesAnddimensionsMap[otherKey] = true;
      }
    }
    option.dataset.source.push(dataItem);
  }

  if (typeof xAxisDataSortter === 'function') {
    option.xAxis.data = xAxisDataSortter(option.xAxis.data);
  }

  option.series = handleSerieSymbolConfigByDataSet(option.series, data);

  return option;
};

const getChartDynamicOptionDataByOutterConfig = (
  data: IEChartDataEntity[],
  config?: {
    xAxisData?: string[];
    dimensions?: string[];
  },
) => {
  const { xAxisData, dimensions } = config || {};
  const xAxisDataTemp: string[] = Array.isArray(xAxisData) ? xAxisData : [];
  const dimensionsTemp: string[] = Array.isArray(dimensions) ? dimensions : [];
  const sourcesTemp: IEChartDataEntity[] = Array.isArray(data) ? data : [];
  let seriesTemp: IEChartSeriesOption[] = dimensionsTemp.slice(1).map((dimension) => ({
    ...BASE_LINE_SERIES_OPTION,
    name: dimension,
    showSymbol: true,
  }));
  // 判断是否有孤立被断开却有数据的点，这种点需要单独显示出来
  // if (xAxisDataTemp.length > 1) {
  //   seriesTemp = handleSerieSymbolConfigByDataSet(seriesTemp, data);
  // }
  seriesTemp = handleSerieSymbolConfigByDataSet(seriesTemp, data);

  return {
    xAxis: {
      data: xAxisDataTemp,
    },
    series: seriesTemp,
    dataset: {
      dimensions: dimensionsTemp,
      source: sourcesTemp,
    },
  };
};

export const getChartDynamicOptionData = (
  data: IEChartDataEntity[],
  config: {
    xAxisEncode?: string;
    xAxisDataSortter?: (xAxisData: string[]) => string[];
    xAxisData?: string[];
    dimensions?: string[];
  },
): IEChartDynamicOption => {
  const { xAxisEncode, xAxisDataSortter, ...restConfig } = config;
  if (xAxisEncode) return getChartDynamicOptionDataByXAxisEncode(data, xAxisEncode, xAxisDataSortter);
  return getChartDynamicOptionDataByOutterConfig(data, restConfig);
};
